import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'img-full',
    position: 'left',
    imgId: 'dasproject-foto-bassam-11_yyeeev',
    alt: 'dasProject Foto Bassam',
    aspectRatio: 1.5
  },
  {
    type: 'group',
    position: 'right',
    text: 'Das ist Bassam.',
    firstImg: {
      id: 'dasproject-foto-bassam-04_gsd1i9',
      alt: 'dasProject Foto Bassam',
      aspectRatio: 1.5
    },
    secondImg: {
      id: 'dasproject-foto-bassam-07_hpogst',
      alt: 'dasProject Foto Bassam',
      aspectRatio: 1.5
    }
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'dasproject-foto-bassam-10_upfirf',
    alt: 'dasProject Foto Bassam',
    aspectRatio: 1.5
  }
]

const color = 'yellow'

export default class ReactComponent extends React.Component {
  render () {
    return (
      <div>
        <Person content={content} color={color} name='Bassam' next={7} previous={5}/>
      </div>
    )
  }
}

exports.data = {
  color: 'yellow',
  number: 7
}



// WEBPACK FOOTER //
// ./bassam.js